var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40_3842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8674 12.3919L16.6307 12.3913C16.0903 12.3913 15.6523 12.8293 15.6523 13.3696V17.2787C15.6523 17.8189 16.0903 18.257 16.6306 18.257H23.5216C22.767 20.2153 21.3587 21.8552 19.5618 22.8973L22.5001 27.9837C27.2135 25.2578 30.0001 20.4748 30.0001 15.1206C30.0001 14.3583 29.9439 13.8133 29.8316 13.1997C29.7461 12.7334 29.3414 12.3919 28.8674 12.3919Z",
    fill: "#167EE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9994 24.1304C11.6271 24.1304 8.68307 22.2879 7.10191 19.5613L2.01562 22.493C4.604 26.9791 9.45287 30 14.9994 30C17.7203 30 20.2877 29.2674 22.4994 27.9907V27.9837L19.5611 22.8972C18.217 23.6767 16.6617 24.1304 14.9994 24.1304Z",
    fill: "#12B347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 27.9907V27.9837L19.5617 22.8972C18.2177 23.6767 16.6625 24.1304 15 24.1304V30C17.7209 30 20.2884 29.2674 22.5 27.9907Z",
    fill: "#0F993E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.86957 15C5.86957 13.3378 6.3232 11.7826 7.10256 10.4387L2.01627 7.50697C0.732539 9.71168 0 12.2721 0 15C0 17.7279 0.732539 20.2883 2.01627 22.493L7.10256 19.5613C6.3232 18.2174 5.86957 16.6622 5.86957 15Z",
    fill: "#FFD500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9994 5.86957C17.1984 5.86957 19.2184 6.65098 20.7962 7.95076C21.1854 8.27139 21.7511 8.24824 22.1077 7.8917L24.8774 5.12197C25.2819 4.71744 25.2531 4.05527 24.821 3.68039C22.1775 1.38709 18.738 0 14.9994 0C9.45287 0 4.604 3.02092 2.01562 7.50697L7.10191 10.4387C8.68307 7.71211 11.6271 5.86957 14.9994 5.86957Z",
    fill: "#FF4B26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7968 7.95076C21.186 8.27139 21.7518 8.24824 22.1083 7.8917L24.878 5.12197C25.2825 4.71744 25.2537 4.05527 24.8216 3.68039C22.1781 1.38703 18.7387 0 15 0V5.86957C17.199 5.86957 19.219 6.65098 20.7968 7.95076Z",
    fill: "#D93F21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_3842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.9457f20bbad2c1c2446cb144be0385d1.svg";
export { ForwardRef as ReactComponent };